<template>
  <div
    class="modal fade"
    :id="id"
    :style="{ zIndex: zIndex }"
    tabindex="-1"
    aria-hidden="true"
    data-bs-backdrop="static"
  >
    <div class="modal-dialog" role="document" :class="cssClass">
      <div class="modal-content">
        <slot class="modal-header" name="header"></slot>
        <slot name="body"></slot>
        <slot class="modal-footer" name="footer"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Modal',
  props: ['id', 'cssClass', 'zIndex'],
};
</script>

<style lang="scss" scoped>
.btn-close-modal {
  position: absolute;
  top: 10px;
  right: 10px;
}
</style>
